/**
 * Duplicates `apps/backend/src/modules/ai/audio-usages.ts`: no type is shared between the two
 * applications, so this list is necessarily a second definition of the same rule. A model requires a
 * `family` if and only if it carries one of these usages — server and screen must list the exact
 * same values, or the form hides the field while the API still rejects it in `400`.
 *
 * `speaker_diarization` is deliberately excluded: it runs as a second pass over a transcript another
 * model already produced, never as a call against raw audio.
 */
const AUDIO_USAGES: readonly string[] = [
	'interview_transcription',
	'dictation',
	'live_interview_transcription',
	'live_dictation',
];

export default AUDIO_USAGES;
